import React from 'react'
import Modal from 'react-modal'
import { ClassNames, css } from '@emotion/core'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import styled, { CSSObject } from '@emotion/styled'
import { mediaQueries } from '@src/styles/theme'
import { Flex } from '../Boxes'
import { FaChevronLeft } from 'react-icons/fa'

const defaultModalDialogStyle = css`
  position: relative;
  margin: 30px 15px;
  ${mediaQueries[0]} {
    max-width: 620px;
    margin: 30px auto;
  }
  background: #fff;
  z-index: 1000;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  background-clip: padding-box;
  outline: 0;
`
const defaultOverlayStyle = css`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  transition: opacity 0.15s linear;
  overflow-y: scroll;
  z-index: 99999;
`

const fullScreenStyle = css`
  width: 100vw !important;
  height: 100% !important;
  max-width: 100vw !important;
  margin: 0 !important;
`

const CloseButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 55px;
  height: 55px;
  line-height: 1;
  margin-top: 0;
  font-size: 28px;
  opacity: 1;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  font-weight: 700;
  color: #000;
  border: 0;
  text-shadow: 0 1px 0 #fff;
`

const ModalHeader = styled.h3`
  text-align: center;
  margin: 20px 0 24px;
  font-size: 21px;
  line-height: 1.4;
  font-weight: 800;
`

const CloseFullScreenButton = styled.button`
  display: flex;
  align-items: center;
  color: #adadad;
  border: 0;
  float: left;
  height: 50px;
  margin: 12px 16px;
  position: absolute;
  width: auto;
  font-size: 20px;
  background: transparent;
  text-shadow: 0 1px 0 #fff;
  z-index: 100;
  font-weight: 700;
  line-height: 1;
  top: 0;
  left: 0;
  cursor: pointer;
  &:hover {
    background-color: #eee;
  }
`

type CommonModalProps = {
  closeModal: () => void
  children: any
  headerText: string | React.ReactNode
  noHeader?: boolean
  noHeaderText?: boolean
  fullScreen?: boolean
  modalDialogStyle?: CSSObject
  closeModalAction?: () => void
}

const CommonModal = ({
                       closeModal,
                       closeModalAction,
                       headerText,
                       modalDialogStyle,
                       noHeader,
                       noHeaderText,
                       fullScreen,
                       children
                     }: CommonModalProps) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(name: { eq: "classdojo-logo-round-120x120" }) {
        childImageSharp {
          fixed(width: 60, quality: 90) {
            ...GatsbyImageSharpFixed_noBase64
          }
        }
      }
    }
  `)

  const { logo } = data

  return (
    <ClassNames>
      {({ css: classCSS }) => {
        const modalClass = fullScreen
          ? classCSS`${defaultModalDialogStyle}; ${modalDialogStyle}; ${fullScreenStyle}`
          : classCSS`${defaultModalDialogStyle}; ${modalDialogStyle}`
        return (
          <Modal
            isOpen={true}
            className={modalClass}
            overlayClassName={classCSS`${defaultOverlayStyle}`}
            onRequestClose={closeModal}
            onAfterClose={closeModalAction}
          >
            {fullScreen ? (
              <CloseFullScreenButton onClick={closeModal}>
                <FaChevronLeft/> <span> Go Back</span>
              </CloseFullScreenButton>
            ) : (
              <CloseButton onClick={closeModal}>×</CloseButton>
            )}
            <Flex flexDirection="column" alignItems="center">
              {!noHeader && <Img fixed={logo.childImageSharp.fixed} loading="eager"/>}
              {!noHeader && !noHeaderText && <ModalHeader>{headerText}</ModalHeader>}
              {children}
            </Flex>
          </Modal>
        )
      }}
    </ClassNames>
  )
}

export { ModalHeader }
export default CommonModal
